<template>
	<div @click="imageClick" class="goods-image-box" :style="imgSize">
        <img class="goods-image" :src="$util.img(imageInfo.sku_image || imageInfo.goods_image)" @error="goodsImageError()"/>
        <template v-if="returnActiveImage">
            <img class="goods-active-image" :src="$util.img(returnActiveImage)"/>
        </template>
        <template v-if="!isShowGoodsLevel && showLable">
            <div class="goods-label-box">
                <goods-code-label :goods="goods">
					<template #start>
						<goods-label :goods="goods"></goods-label>
					</template>
				</goods-code-label>
            </div>
        </template>
		<template v-if="isShowGoodsLevel">
			<div class="goods-level">
				<goods-level :goods="goods"></goods-level>
			</div>
		</template>
		<template v-if="isShowGoodsOutOfStock">
			<div class="goods-out-of-stock">
				<div>
					<span :style="returnOutOfStock_style">已售罄</span>
				</div>
			</div>
		</template>
    </div>
</template>
<script>
import goodsLabel from "../goods-label/goods-label.vue";
import goodsCodeLabel from "../goods-label/goods-code-label.vue";
import goodsLevel from "../goods-label/goods-level.vue";
export default {
	name: "goods-list-item",
    components: {goodsLabel,goodsCodeLabel,goodsLevel},
	props: {
		goods: {
			type: Object,
			required: true,
			default: ''
		},
		imageSize: {
			type: [Number, String],
			default: 200
		},
        showLable: {
            type: Boolean,
            default: false
        },
		showOutOfStock: {
			type: Boolean,
			default: true
		}
	},
	watch: {
		goods: {
			deep: true,
			handler() {
				let temObj = JSON.parse(JSON.stringify(this.goods));
				if(temObj.goods){
					temObj = Object.assign(temObj,temObj.goods);
				}
				this.imageInfo = temObj;
			}
		}
	},
	data() {
		return {
			imageInfo:{}
		}
	},
	computed: {
		returnActiveImage(){
			return this.imageInfo.border_image || ''
		},
		imgSize() {
			return `width: ${this.imageSize}px;height: ${this.imageSize}px;max-width: ${this.imageSize}px;max-height: ${this.imageSize}px;`;
		},
		isShowGoodsLevel(){
			let bool = false;
			if(this.imageInfo && this.imageInfo.goods_level){
				bool = true;
			}
			return bool;
		},
		isShowGoodsOutOfStock(){
			let bool = false;
			if(this.goods && this.showOutOfStock){
				let stock = this.goods.stock ?? this.goods.goods_stock ?? 1;
				if(Number(stock)<=0){
					bool = true;
				}
			}
			return bool;
		},
		returnOutOfStock_style(){
			let size = 16;
			if(this.imageSize<80){
				size = 12;
			}
			return `font-size: ${size}px;`
		}
	},
	mounted() {
		let temObj = JSON.parse(JSON.stringify(this.goods));
		if(temObj.goods){
			temObj = Object.assign(temObj,temObj.goods);
		}
		this.imageInfo = temObj;
	},
	methods: {
		goodsImageError() {
			this.imageInfo.sku_image = this.$util.img();
		},
		imageClick(){
			this.$emit('click',this.imageInfo);
		}
	}
}
</script>


<style scoped lang="scss">
.goods-image-box{
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
}
.goods-image {
	width: 100%;
	height: 100%;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
	position: relative;
	z-index: 1;
}
.goods-active-image{
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	flex-shrink: 0;
	object-fit: contain;
	box-sizing: border-box;
	z-index: 2;
}
.goods-label-box{
    position: absolute;
    left: 0;
    top: 0;
    height: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 2px;
    z-index: 3;
    >img{
        height: 100%;
    }
}
.goods-level{
	position: absolute;
	left: 0;
	top: 0;
	z-index: 2;
}
.goods-out-of-stock{
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
    z-index: 13;
	>div{
		background-color: rgba(0,0,0,0.5);
		width: 60%;
		height: 60%;
		aspect-ratio: 1/1;
		border-radius: 50%;
		display: flex;
		align-items: center;
		justify-content: center;
		>span{
			font-size: 16px;
			color: #ffffff;
		}
	}
}
</style>
